/**
 * 检测是否为空
 */
export const isNull = (e) => {
  return e === undefined || e === 'undefined' || e == null || e === '' || e === 0 || e.length == 0
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}


export const  formatNumber = (n) => { // 1转换成01
  n = n.toString()
  return n[1] ? n : '0' + n
}

export function toLoginPage() { 
    window.location.href = window.login_page_url + '?redirect_uri=' + encodeURI(window.location.href)
    window.location.href = window.location.origin+'/college/index.php/college/auth/login' + '?redirect_uri=' + encodeURI(window.location.href)

}

export const localStorageCache = {
  fetch: (key) => {
      return JSON.parse(window.localStorage.getItem(key))
  },

  save: (key,val) => {
      window.localStorage.setItem(key,JSON.stringify(val))
  },

  remove: (key) => {
      window.localStorage.removeItem(key)
  }
}


/**
 * 格式化时间
 */
export const  getCurrentDate = (date=new Date()) => { //处理当前时间转换成各种格式
  var today = date //时间对象
  var year = today.getFullYear() //年
  var month = today.getMonth() + 1 //月
  var day = today.getDate() //日
  // var week = today.getDay() //天
  var hour = today.getHours() //时
  var minute = today.getMinutes() //分
  var second = today.getSeconds() //秒

  function getFullDate() { //2018/01/01
    return [year, month, day].map(formatNumber).join('-')
  }

  function getYearMonth() { //2018/01
    return [year, month].map(formatNumber).join('-')
  }

  function getYear() { //2018
    return year
  }

  function getMonthDay() { //01/01
    return [month, day].map(formatNumber).join('-')
  }

  function getFullHourMinute() { //09:00
    return [hour, minute].map(formatNumber).join(':')
  }

  function getFullTime() { //09:00:00
    return [hour, minute, second].map(formatNumber).join(':')
  }

  function getMonth() { //09
    return month
  }

  function getDay() { //09
    return day
  }

  function getHour() { //09
    return hour
  }

  return {
    getFullDate,
    getYear,
    getYearMonth,
    getMonthDay,
    getFullHourMinute,
    getFullTime,
    getMonth,
    getDay,
    getHour,
    toLoginPage,
  }
}
